import { all, takeEvery, put, call } from 'redux-saga/effects';
import * as coordinatorService from '../../services/coordinator';
import actions from './actions';
import toastr from 'toastr';
import {history} from "../../index";

export function* list({ payload }) {
  const { page, countryId } = payload;

  yield put({
    type: 'coordinator/SET_STATE',
    payload: {
      loadingList: true,
    },
  });

  const response = yield call(coordinatorService.list, page, countryId);

  if (response && response.status === 200) {
    const { data } = response;

    yield put({
      type: 'coordinator/SET_STATE',
      payload: {
        list: data.data,
        meta: data.meta
      },
    })
  }

  yield put({
    type: 'coordinator/SET_STATE',
    payload: {
      loadingList: false,
    },
  })
}

export function* details({ payload }) {
  const { id } = payload;

  yield put({
    type: 'coordinator/SET_STATE',
    payload: {
      loadingDetails: true,
    },
  });

  const response = yield call(coordinatorService.details, id);

  if (response && response.status === 200) {
    const { data } = response;

    yield put({
      type: 'coordinator/SET_STATE',
      payload: {
        details: data.data
      },
    })
  }

  yield put({
    type: 'coordinator/SET_STATE',
    payload: {
      loadingDetails: false,
    },
  })
}

export function* add({ payload }) {
  const response = yield call(coordinatorService.add, payload);

  if (response && response.status >= 200 && response.status <= 201) {
    const { data } = response;

    toastr.success(data.message, '', { positionClass: "toast-bottom-right", tapToDismiss: true });
    yield history.push('/coordinators');
  }

  if (response && response.status >= 400 && response.status <= 422) {
    if (response.data.errors) {
      yield put({
        type: 'coordinator/SET_STATE',
        payload: {
          errors: response.data.errors,
        }
      });
    }
  }
}

export function* edit({ payload }) {
  const { id, data } = payload;

  const response = yield call(coordinatorService.edit, id, data);

  if (response && response.status >= 200 && response.status <= 201) {
    const { data } = response;

    toastr.success(data.message, '', { positionClass: "toast-bottom-right", tapToDismiss: true });
    yield history.push('/coordinators');
  }

  if (response && response.status >= 400 && response.status <= 422) {
    if (response.data.errors) {
      yield put({
        type: 'coordinator/SET_STATE',
        payload: {
          errors: response.data.errors,
        }
      });
    }
  }
}

export function* refreshErrors() {
  yield put({
    type: 'coordinator/SET_STATE',
    payload: {
      errors: {},
    },
  })
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.REFRESH_ERRORS, refreshErrors),
    takeEvery(actions.FETCH_ALL, list),
    takeEvery(actions.DETAILS, details),
    takeEvery(actions.ADD, add),
    takeEvery(actions.EDIT, edit)
  ])
}
